import DOMPurify from 'dompurify';

// Callers pass DOMPurify options so each island keeps its own tag rules.

export function sanitizeHtml(html, options = {}) {
  return DOMPurify.sanitize(String(html ?? ''), options);
}
